import { css } from 'styled-components';

import { screenSizes } from 'theme/screenSizes';

export const media = Object.assign(
  Object.keys(screenSizes).reduce((acc, label) => {
    acc[label] = (...args) => css`
      @media (min-width: ${screenSizes[label]}px) {
        ${css(...args)};
      }
    `;

    return acc;
  }, {}),
  {
    mobileOnly: (...args) => css`
      @media (max-width: ${screenSizes.tablet - 1}px) {
        ${css(...args)};
      }
    `,
    tinyMobileOnly: (...args) => css`
      @media (max-width: ${screenSizes.smallMobile - 1}px) {
        ${css(...args)};
      }
    `,
  }
);
